module.exports = __webpack_public_path__ + "img/a1-s29.fdc7734a.jpg";